import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import { useAuth } from './useAuth'

export const useWhatsNew = () => {
  const { user } = useAuth()
  const qc = useQueryClient()

  const query = useQuery({
    queryKey: ['whats-new'],
    enabled: !!user?.id,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('whats_new')
        .select('id, title, body, version, seen_by, created_at')
        .order('created_at', { ascending: false })
      if (error) throw error
      return data ?? []
    },
  })

  const markSeen = useMutation({
    mutationFn: async (entryId) => {
      const entry = (query.data ?? []).find((e) => e.id === entryId)
      if (!entry) return
      const seenBy = Array.isArray(entry.seen_by) ? entry.seen_by : []
      if (seenBy.includes(user.id)) return
      const { error } = await supabase
        .from('whats_new')
        .update({ seen_by: [...seenBy, user.id] })
        .eq('id', entryId)
      if (error) throw error
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['whats-new'] }),
  })

  const post = useMutation({
    mutationFn: async ({ title, body, version }) => {
      const { error } = await supabase.from('whats_new').insert({ title, body, version })
      if (error) throw error
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['whats-new'] }),
  })

  const unreadCount = (query.data ?? []).filter(
    (e) => !(Array.isArray(e.seen_by) ? e.seen_by : []).includes(user?.id)
  ).length

  return { ...query, markSeen, post, unreadCount }
}
